import { Button, Form, Accordion } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { getHostName } from "../helpers/utils";
import PageHeader from "./PageHeader";

export default function AffiliateProgram() {
  const hostname = getHostName();

  // const [loader, setLoader] = useState(false);

  const ApplyForDB = async (values, { setSubmitting, resetForm }) => {
    console.log(values);
    // setSubmitting(false);

    // let obj = { ...values };

    // console.log(obj);

    // return;

    axios
      .post(`${hostname}/api/users/apply-for-affiliate`, {
        ...values,
      })
      .then((res) => {
        console.log(res.data);
        toast.success("Request Sent. we will reach you shortly via email", {
          theme: "colored",
        });
        setSubmitting(false);
        resetForm();
      })
      .catch((err) => {
        console.log(err);
        setSubmitting(false);
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  return (
    <>
      <PageHeader seoKey={"affiliateProgram"} />
      <section className="container py-5">
        <div className="row g-4">
          <div className="col-lg-6">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-4">
                <h5 className="fw-bold mb-4">Apply for Affiliate</h5>
                <Formik
                  initialValues={{
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: "",
                    reference_by_code: "",
                    address: "",
                    city: "",
                    postal: "",
                    country: "Pakistan",
                  }}
                  validationSchema={Yup.object().shape({
                    first_name: Yup.string().required("First name is required"),
                    last_name: Yup.string().required("Last name is required"),
                    email: Yup.string()
                      .email("Invalid email")
                      .matches(
                        /^[\w.+-]+@gmail\.com$/,
                        "Only @gmail.com emails are allowed"
                      )
                      .required("Email is required"),
                    phone: Yup.string().required("Phone is required"),
                    reference_by_code: Yup.string().required(
                      "Referral Code is required"
                    ),

                    address: Yup.string(),
                    city: Yup.string(),
                    postal: Yup.string(),
                    country: Yup.string(),
                  })}
                  onSubmit={ApplyForDB}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <Form.Label>First Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="first_name"
                            value={values.first_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.first_name && !!errors.first_name
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.first_name}
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="last_name"
                            value={values.last_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.last_name && !!errors.last_name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.last_name}
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.email && !!errors.email}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            type="text"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.phone && !!errors.phone}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-3">
                          <Form.Label>Referral Code</Form.Label>
                          <Form.Control
                            type="text"
                            name="reference_by_code"
                            value={values.reference_by_code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.reference_by_code &&
                              !!errors.reference_by_code
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.reference_by_code}
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-3">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            type="text"
                            name="address"
                            value={values.address}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            value={values.city}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <Form.Label>Postal Code</Form.Label>
                          <Form.Control
                            type="text"
                            name="postal"
                            value={values.postal}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <Form.Label>Country</Form.Label>
                          <Form.Control
                            type="text"
                            name="country"
                            value={values.country}
                            onChange={handleChange}
                            disabled
                          />
                        </div>
                        <div className="col-md-12" style={{ marginTop: "5px" }}>
                          <label style={{ marginBottom: "10px" }}>
                            Payment
                          </label>
                          <br />

                          <Accordion alwaysOpen>
                            <Accordion.Item eventKey="0">
                              <Accordion.Header>
                                <span className="me-2">
                                  <i className="bi bi-bank2 custom-accordion-icon"></i>
                                </span>
                                Bank Deposit
                              </Accordion.Header>
                              <Accordion.Body>
                                IBAN: PK95MEZN0002460107600100 <br />
                                Account Title: <br />
                                MOHAMMAD MOHSIN AMEER
                                <br />
                                Account Number: 02460107600100
                                <br />
                                Bank: Meezan Bank
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      </div>
                      <div className="text-end">
                        <br />
                        <Button
                          type="submit"
                          variant="primary"
                          disabled={isSubmitting}
                        >
                          Apply
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
          <div className="col-lg-6" >
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-4" style={{maxHeight:'700px',overflowY:'scroll'}}>
                <h5 className="fw-bold mb-4">Aura Affiliate Program – Official Terms & Conditions</h5>

                <h6 className="fw-bold mt-4">1. Joining Requirement</h6>
                <ul>
                  <li>Every affiliate must purchase 1 Starter Bundle (3in1 Pack – Rs. 6400) at the time of joining.</li>
                  <li>Registration form & payment proof must be submitted.</li>
                  <li>After approval, the affiliate will receive a username & password.</li>
                </ul>

                <h6 className="fw-bold mt-4">2. Sales & Profit</h6>
                <ul>
                  <li>Each soap sale will earn the affiliate <strong>Rs. 500</strong> profit.</li>
                  <li>Each 3in1 Bundle sale will earn the affiliate <strong>Rs. 1500</strong> profit.</li>
                  <li>Earnings are based only on personal direct sales.</li>
                  {/* <li>There will be no “team income” or “binary system”.</li> */}
                </ul>

                <h6 className="fw-bold mt-4">3. Order & Delivery</h6>
                <ul>
                  <li>All orders will be processed through the company’s official system.</li>
                  <li>Delivery charges will be covered by the company (customers get Free Delivery).</li>
                  <li>Product packaging & branding will remain under Aura Skin Premium.</li>
                </ul>

                <h6 className="fw-bold mt-4">4. Payout Policy</h6>
                <ul>
                  <li>Profit payout will be made monthly (between 1st–5th of each month).</li>
                  <li>Minimum withdrawal limit: Rs. 2000.</li>
                  <li>Payment methods: Bank Transfer / Easypaisa / JazzCash.</li>
                </ul>

                <h6 className="fw-bold mt-4">5. Affiliate Responsibilities</h6>
                <ul>
                  <li>Products must be sold at the company’s approved prices.</li>
                  <li>Unauthorized discounts or price manipulation are strictly prohibited.</li>
                  <li>It is recommended to use company-provided marketing materials.</li>
                  <li>Fake orders, fraud, or unethical selling will result in immediate account termination.</li>
                </ul>

                <h6 className="fw-bold mt-4">6. Refund / Return Policy (for Customers)</h6>
                <ul>
                  <li>Damaged or defective products are eligible for replacement within 7 days.</li>
                  <li>Refunds are allowed only in exceptional cases (with admin approval).</li>
                  <li>Change of mind refunds are not possible once delivery is completed.</li>
                </ul>

                <h6 className="fw-bold mt-4">7. Privacy Policy</h6>
                <ul>
                  <li>Affiliate’s personal details (Name, Phone, Email, Bank Info) will remain safe and secure.</li>
                  <li>The company will never share data with any third party.</li>
                </ul>

                <h6 className="fw-bold mt-4">8. Termination Clause</h6>
                <ul>
                  <li>If an affiliate violates rules (fake orders, price manipulation, spam marketing), their account may be terminated without notice.</li>
                  <li>Terminated affiliates will lose the right to claim any pending payouts.</li>
                </ul>

                <h6 className="fw-bold mt-4">9. Company Rights</h6>
                <ul>
                  <li>Aura Skin Premium reserves the right to update terms at any time.</li>
                  <li>The company reserves the right to approve or reject any affiliate application at its discretion.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
